import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";

import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { debounceTime, distinctUntilChanged, filter, forkJoin, Subject, Subscription, switchMap } from 'rxjs';

import { NgSelectComponent } from '@ng-select/ng-select';

import * as moment from 'moment';


import { CommonModule } from '@angular/common';

import { AgGridAngular } from '@ag-grid-community/angular';
import { SharedModule } from "src/app/shared/shared.module";
import { CCY_SORT_ORDER } from "src/app/shared/constants/helpers.const";
import { EntityFormProvider } from "../common/providers/entity-form.provider";
import { EntitiesHttpService } from "../common/services/entities-http.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { EntityItem, EntityResponse } from "src/app/shared/interfaces/entity-response.interface";
import { getModelChanges } from "src/app/shared/helpers/utils";
import { confirmMessage } from "src/app/shared/helpers/messages-popup";
import parsePhoneNumber from 'libphonenumber-js';
import { NgbActiveModal, NgbDate, NgbDatepickerConfig } from "@ng-bootstrap/ng-bootstrap";
import { COUNTRY_LIST } from "src/app/shared/constants/countryList.const";
import { EntityQueryParams } from "src/app/shared/interfaces/entity-query-params";


@Component({
  standalone: true,
  selector: 'app-add-edit-entity',
  templateUrl: './add-edit-entity.component.html',
  styleUrls: ['./add-edit-entity.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, AgGridAngular],
})
export class AddEditEntityComponent implements OnInit, OnChanges {
  entityForm: FormGroup;
  roleList: { id: number; name: string }[];
  typeList: { id: number; name: string }[] = [
    { id: 1, name: 'Organisation' },
    { id: 2, name: 'Person' },
  ];
  entityList: any;
  banksList: { id: number; name: string }[] = [];
  areasList: any;
  citiesList: string[];
  statesList: string[];
  countriesList: { id: string; name: string }[] = [];
  isNewEntity: boolean;
  entityNameList: { id: string; name: string }[] = [];
  organisationList: { id: string; name: string }[] = [];
  ccyList: Array<{ id: string; name: string }> = CCY_SORT_ORDER.reduce(
    (
      accumulator: {
        id: string;
        name: string;
      }[],
      currentValue: string,
    ) => {
      accumulator.push({ id: currentValue, name: currentValue });
      return accumulator;
    },
    [],
  );
  bankInformationSettings: Record<string, boolean | 'none'> = {
    Agent: false,
    Broker: false,
    Debtor: false,
    Leasee: false,
    Supplier: false,
    Trustee: false,
    User: false,
    Creditor: true,
    Investor: true,
    Originator: true,
    Intermediary: true,
    Asset: 'none',
    Credebtor: 'none',
  };
  isBankRequired: boolean | 'none';
  showBankDetailsBlock = true;
  // isPerson = true;
  isShowPreviousInput: boolean;
  isShowCompany: boolean;

  private subscriptions: Subscription[] = [];
  private deleteAddress: number[] = [];
  private deleteBanks: number[] = [];

  @Input() currentEntity: any;
  @Input() distinctValues: any;
  @Input() isCompareDialog: boolean;
  @Input() currencyBankAccountsData: any;
  @Input() isPerson = true;
  @Output() closeDialogEvent = new EventEmitter<boolean>();
  @Output() createUpdateEvent = new EventEmitter<boolean>();
  @ViewChild('nameNgSelect') nameNgSelect: NgSelectComponent;

  toggleSettings = {
    labels: {
      unchecked: 'Person',
      checked: 'Organisation',
    },
    values: {
      unchecked: 'person',
      checked: 'organisation',
    },
    switchColor: {
      checked: '#fff',
      unchecked: '#fff',
    },
    color: {
      unchecked: '#d4d5db',
      checked: '#d4d5db',
    },
    fontColor: {
      checked: 'black',
      unchecked: 'black',
    },
  };
  isPersonEntity = true;
  showDropdown = false;
  allOptions: any[] = []; // Your full list of names
  filteredOptions: any[] = [];

  searchTermSubject = new Subject<string>();
  timeout: any;
  constructor(
    private entityFormProvider: EntityFormProvider,
    private entitiesHttpService: EntitiesHttpService,
    private spinnerService: SpinnerService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private config: NgbDatepickerConfig,
    public activeModal: NgbActiveModal,
  ) {
    this.initDatePickerConfig();

    this.searchTermSubject.pipe(debounceTime(300), switchMap((searchTerm) => this.getEntitiesData(searchTerm))).subscribe({
      next: (response: EntityResponse) => {
        this.processEntities(response);
      },
    });
  }

  onSearchInput(event: any) {
    const searchTerm = event.target.value;
    if (searchTerm.length >= 3) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.searchTermSubject.next(searchTerm);
      }, 300);
    }
    else {
      this.filteredOptions = [];
    }

  }

  selectOption(option: any) {
    this.currentEntity = option;
    this.initEntityForm(option);
    this.entityForm?.get('name')?.setValue('');
    this.showDropdown = false;
  }

  onBlur() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  ngOnInit(): void {
    this.getDistinctValues();
    this.initSelectOptionsData();
    this.getBanksList();
    this.initEntityForm(this.currentEntity);
    // Subscribe to sortCode value changes for the initial FormGroup
    const bankDetailsArray = this.entityForm.get('bankDetails') as FormArray;
    if (bankDetailsArray && bankDetailsArray.length > 0) {
      this.subscribeToSortCodeValueChange(bankDetailsArray.at(0) as FormGroup);
    }
    this.getOrganisationList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isPerson'] && !changes['isPerson'].firstChange) {
      this.handleTypeChange();
    }
  }

  initEntityForm(data: EntityItem): void {
    this.isNewEntity = !this.currentEntity?.id;
    this.entityFormProvider.initEntityForm(data);
    this.entityForm = this.entityFormProvider.entityForm;
    if (!this.isNewEntity) {
      this.isPerson = data?.type === 2;
      this.isShowPreviousInput = data.isPrevious;
      this.addNewTag(data?.name);
    }
    this.changeFormValidators(this.isPerson);
    this.cdr.detectChanges();
  }

  getDistinctValues() {
    this.entitiesHttpService.getFilterDistinctValues().subscribe((response) => {
      this.distinctValues = response;
      this.initSelectOptionsData();
    });
  }

  get emailControls() {
    return (this.entityForm.get('email') as FormArray).controls as FormControl[];
  }

  get mobilePhonesControls() {
    return this.entityForm.get('mobilePhones') as any;
  }

  get homePhonesControls() {
    return this.entityForm.get('homePhones') as any;
  }

  get officePhonesControls() {
    return this.entityForm.get('officePhones') as any;
  }

  get addressArray(): FormArray {
    return this.entityForm.get('addresses') as FormArray;
  }

  get bankDetailsArray(): FormArray {
    return this.entityForm.get('bankDetails') as FormArray;
  }

  private getBanksList(): void {
    this.entitiesHttpService.getBanksList().subscribe((response) => {
      this.banksList = response;
    });
  }

  private initSelectOptionsData(): void {
    this.roleList = [
      ...(this.distinctValues?.roles
        ?.filter((item: string) => !['Bank', 'Owner', 'Unassigned', 'Asset', 'Agent'].includes(item))
        .map((status: any) => ({
          id: status,
          name: status,
        })) || []),
    ];
    // this.countriesList = this.distinctValues?.countries;
    // @todo need use from API and need change to countries list
    this.countriesList = COUNTRY_LIST.map(item => {
     return {name: item.name, id: item.name}
    });
    this.statesList = this.distinctValues?.states;
    this.citiesList = this.distinctValues?.cities;
  }

  initDatePickerConfig() {
    const currentDate = this.getCurrentDate();
    this.config.minDate = { year: 1910, month: 1, day: 1 };
    this.config.maxDate = currentDate;
  }

  resetDatePickerConfig() {
    this.config.minDate = { year: 1, month: 1, day: 1 };
    this.config.maxDate = { year: 9999, month: 12, day: 31 };
  }

  private getCurrentDate(): NgbDate {
    const today = new Date();
    return new NgbDate(today.getFullYear(), today.getMonth() + 1, today.getDate());
  }

  private getOrganisationList(): void {
    this.entitiesHttpService.getOrganisationList().subscribe((response) => {
      this.organisationList = response.map((item: any) => {
        return { id: item.entityId, name: item.name };
      });
    });
  }

  onSubmit() {
    if (this.entityForm.invalid) return;

    const rawData = this.entityForm.value;
    delete rawData.id;

    this.currentEntity?.id ? this.doUpdate(rawData) : this.doCreate(rawData);
  }

  doCreate(data: any): void {
    if (data.birthDate) {
      const { day, month, year } = data.birthDate;
      data.birthDate = moment(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD');
    }
    const body = {
      ...(data.type && { type: data.type }),
      ...(data.firstName && { firstName: data.firstName }),
      ...(data.lastName && { lastName: data.lastName }),
      ...(data.tradingAs && { tradeName: data.tradingAs }),
      ...(data.roleId && { roleNames: data.roleId }),
      ...(data.birthDate && { birthDate: data.birthDate }),
      ...(data.entityRoleId && { entityRoleId: data.entityRoleId }),
      ...(data.organisationEntityId && { organisationEntityId: data.organisationEntityId }),
      isPrevious: data.isPrevious,
      name: this.isPerson ? `${data.firstName} ${data.lastName}` : data.name,
    };
    this.spinnerService.setShowSpinner(true);
    this.entitiesHttpService.createEntity(body).subscribe({
      next: (response: any) => {
        this.currentEntity = response;
        this.doUpdate(data);
      },
      error: (err) => this.spinnerService.setShowSpinner(false),
    });
  }

  doUpdate(data: any): void {
    if (data.birthDate) {
      const { day, month, year } = data.birthDate;
      data.birthDate = moment(`${year}-${month}-${day}`, 'YYYY-M-D').format('YYYY-MM-DD');
    }
    const entityBody = {
      ...(data.type && { type: data.type }),
      ...(data.firstName && { firstName: data.firstName }),
      ...(data.lastName && { lastName: data.lastName }),
      ...(data.tradingAs && { tradeName: data.tradingAs }),
      ...(data.roleId && { roleNames: data.roleId }),
      ...(data.birthDate && { birthDate: data.birthDate }),
      ...(data.entityRoleId && { entityRoleId: data.entityRoleId }),
      ...(data.organisationEntityId && { organisationEntityId: data.organisationEntityId }),
      isPrevious: data.isPrevious,
      name: this.isPerson ? `${data.firstName} ${data.lastName}` : data.name,
    };
    const entityAddressBody = this.generateAddressBody(data.addresses);

    data.email = this.checkEmails(data);
    data.mobilePhones = this.checkPhones(data, 'mobilePhones');
    data.homePhones = this.checkPhones(data, 'homePhones');
    data.officePhones = this.checkPhones(data, 'officePhones');
    const entityPropertiesBody = {
      ...(data.email.length && { emails: data.email }),
      ...(data.mobilePhones.length || data.homePhones.length || data.officePhones.length
        ? {
            phoneNumbers: {
              ...(data.mobilePhones.length && { mobile: data.mobilePhones }),
              ...(data.homePhones.length && { home: data.homePhones }),
              ...(data.officePhones.length && { office: data.officePhones }),
            },
          }
        : {}),
      ...(data.previousName && { previousName: data.previousName }),
    };

    const entityBanksBody = this.generateBanksBody(data.bankDetails);

    const entityDocumentsBody = {
      ...(data.POFile && { POFile: data.POFile }),
      ...(data.PoDFile && { PoDFile: data.PoDFile }),
      ...(data.etrFile && { etrFile: data.etrFile }),
      ...(data.fxFile && { fxFile: data.fxFile }),
      ...(data.organisationFile && { organisationFile: data.organisationFile }),
      ...(data.proofFile && { proofFile: data.proofFile }),
      ...(data.signedFile && { signedFile: data.signedFile }),
      entityId: this.currentEntity.id,
    };

    let requestList: any[] = [];

    if (!this.isNewEntity && Object.keys(entityBody).length) {
      // const entityChanged = getModelChanges(entityBody, this.currentEntity);
      requestList.push(this.entitiesHttpService.updateEntity({ entityId: this.currentEntity.id, data: entityBody }));
    }

    if (this.isNewEntity) {
      if (Object.keys(entityAddressBody).length) {
        const addressRequests: any = [];
        entityAddressBody.forEach((item) => {
          const newAddress = { ...item };
          delete newAddress.isNew;
          delete newAddress.id;
          addressRequests.push(
            this.entitiesHttpService.createEntityAddress({
              entityId: this.currentEntity.id,
              data: newAddress,
            }),
          );
        });
        requestList = [...requestList, ...addressRequests];
      }

      if (Object.keys(entityPropertiesBody).length) {
        requestList.push(
          this.entitiesHttpService.updateEntityProperties({
            entityId: this.currentEntity.id,
            data: entityPropertiesBody,
          }),
        );
      }
      if (Object.keys(entityDocumentsBody).length > 1) {
        requestList.push(this.entitiesHttpService.updateEntityDocuments(entityDocumentsBody));
      }
      if (this.checkHasBankInformation(entityBanksBody)) {
        entityBanksBody.forEach((bank) => {
          const newBank = { ...bank };
          delete newBank.isNew;
          delete newBank.id;
          requestList.push(
            this.entitiesHttpService.createEntityBanksAccounts({
              entityRoleId: this.currentEntity.entityRoles[0].id,
              data: newBank,
            }),
          );
        });
      }
    } else {
      if (Object.keys(entityAddressBody).length) {
        // const addressChanged = getModelChanges(entityAddressBody, this.currentEntity.addresses);
        const updateAddressData: any = [];
        const createAddressData: any = [];
        entityAddressBody.forEach((item) => {
          if (item.isNew) {
            const newAddress = { ...item };
            delete newAddress.isNew;
            delete newAddress.id;
            createAddressData.push(
              this.entitiesHttpService.createEntityAddress({
                entityId: this.currentEntity.id,
                data: newAddress,
              }),
            );
          } else {
            const updateAddress = { ...item };
            delete updateAddress.isNew;
            delete updateAddress.id;
            updateAddressData.push(
              this.entitiesHttpService.updateEntityAddress({
                entityId: item.id,
                data: updateAddress,
              }),
            );
          }
        });
        requestList = [...requestList, ...updateAddressData, ...createAddressData];
      }
      if (Object.keys(entityPropertiesBody).length) {
        // const propertiesChanged = getEntityPropertiesChanges(entityPropertiesBody, this.currentEntity.entityProperties);
        requestList.push(
          this.entitiesHttpService.updateEntityProperties({
            entityId: this.currentEntity.id,
            data: entityPropertiesBody,
          }),
        );
      }
      if (Object.keys(entityDocumentsBody).length && Object.keys(getModelChanges(entityDocumentsBody, this.currentEntity.documents)).length) {
        const documentsChanged = getModelChanges(entityDocumentsBody, this.currentEntity.documents);
        requestList.push(this.entitiesHttpService.updateEntityDocuments(entityDocumentsBody));
      }
      if (this.checkHasBankInformation(entityBanksBody)) {
        const updateBankData: any = [];
        const createBankData: any = [];
        entityBanksBody.forEach((bank) => {
          if (bank.isNew) {
            const newBank = { ...bank };
            delete newBank.isNew;
            delete newBank.id;
            createBankData.push(
              this.entitiesHttpService.createEntityBanksAccounts({
                entityRoleId: this.currentEntity.entityRoles[0].id,
                data: newBank,
              }),
            );
          } else {
            const updateBank = { ...bank };
            delete updateBank.isNew;
            delete updateBank.id;
            updateBankData.push(
              this.entitiesHttpService.updateEntityBanksAccounts({
                accountId: bank.id,
                data: updateBank,
              }),
            );
          }
        });
        requestList = [...requestList, ...updateBankData, ...createBankData];
      }
      if (this.deleteAddress.length) {
        this.deleteAddress.forEach((id) => {
          requestList.push(this.entitiesHttpService.deleteEntityAddress(id));
        });
      }
      if (this.deleteBanks.length) {
        this.deleteBanks.forEach((id) => {
          requestList.push(this.entitiesHttpService.deleteEntityBankAccount(id));
        });
      }
    }

    if (requestList.length) {
      this.spinnerService.setShowSpinner(true);
      forkJoin(requestList).subscribe({
        next: (response) => {
          this.closeModal();
          Swal.fire({
            icon: 'success',
            text: `Entity successfully ${this.isNewEntity ? 'added' : 'updated'}.`,
            showConfirmButton: false,
            timer: 5000,
          });
          this.deleteBanks = [];
          this.deleteAddress = [];
          this.spinnerService.setShowSpinner(false);
          this.createUpdateEvent.emit(true);
        },
        error: (error) => {
          this.deleteBanks = [];
          this.deleteAddress = [];
          this.spinnerService.setShowSpinner(false);
        },
      });
    }
  }

  private generateAddressBody(addresses: any[]): any[] {
    return addresses.reduce((acc: any[], cur: any) => {
      const transformedAddress = {
        ...(cur.country && { country: cur.country }),
        ...(cur.countryCode && { countryCode: cur.countryCode }),
        ...(cur.state && { state: cur.state }),
        ...(cur.city && { city: cur.city }),
        ...(cur.area && { area: cur.area }),
        ...(cur.address1 && { lineOne: cur.address1 }),
        ...(cur.address2 && { lineTwo: cur.address2 }),
        ...(cur.postCode && { zipCode: cur.postCode }),
        isNew: cur.isNew,
        id: cur.id,
      };
      acc.push(transformedAddress);
      return acc;
    }, []); // Initialize accumulator as an empty array
  }

  private generateBanksBody(bankDetails: any[]): any[] {
    return bankDetails.reduce((acc: any[], cur: any) => {
      const transformedBankDetails = {
        ...(cur.bankId && { bankId: cur.bankId }),
        ...(cur.bankName && { name: cur.bankName }),
        ...(cur.swiftBic && { swiftBic: cur.swiftBic }),
        ...(cur.sortCode && { sortCode: cur.sortCode?.toString().replace(/-/g, '') }),
        ...(cur.accountNumber && { account: cur.accountNumber }),
        ...(cur.iban && { iban: cur.iban }),
        ...(cur.ccy && { ccy: cur.ccy }),
        ...(cur.isNew && { isNew: cur.isNew }),
        ...(cur.id && { id: cur.id }),
      };
      acc.push(transformedBankDetails);
      return acc;
    }, []); // Initialize accumulator as an empty array
  }

  private checkEmails(data: any): string[] {
    return data.email.filter((item: string) => item);
  }

  private checkPhones(data: any, type: string): string[] {
    return data[type]
      .map((item: any) => `${item.countryCode || ''}${item.areaCode || ''}${item.mobileNumber || ''}`)
      .filter((phone: string) => phone.trim() !== '');
  }

  private checkHasBankInformation(data: any[]): boolean {
    let hasBankInformation = false;
    if (data.length) {
      data.forEach((item) => {
        hasBankInformation = !!Object.keys(item).length;
      });
    }
    return hasBankInformation;
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  handleBankChange(event: any, index: number) {
    const banksFormArray = this.bankDetailsArray;
    const lastGroup = banksFormArray.at(index) as FormGroup;
    lastGroup.get('bankName')?.patchValue(event?.name);
  }

  handleRoleChange(event: any) {
    let isAnyTrue = false; // Tracks if any selected value is `true`
    let isAnyNone = false; // Tracks if any selected value is `none`
    this.showBankDetailsBlock = true;

    if (event.length) {
      for (let i = 0; i < event.length; i++) {
        const setting = this.bankInformationSettings[event[i].id];
        if (setting === true) {
          isAnyTrue = true;
          break; // If any value is `true`, others are irrelevant
        }
        if (setting === 'none') {
          isAnyNone = true;
        }
      }

      // If any `true`, fields are required
      if (isAnyTrue) {
        this.isBankRequired = true;
        this.updateBankDetailsValidators(true);
        return;
      }

      // If all are `none` or `false`, fields are not required
      this.isBankRequired = isAnyNone ? 'none' : false;
    } else {
      // No selection, fields are not required
      this.isBankRequired = false;
    }

    this.updateBankDetailsValidators(false);
  }

  handleRoleChange2(event: any) {
    let validatorStatus = false;
    if (event.length) {
      for (let i = 0; i <= event.length - 1; i++) {
        if (this.bankInformationSettings[event[i].id] && this.bankInformationSettings[event[i].id] !== 'none') {
          this.isBankRequired = true;
          validatorStatus = false;
          return;
        }
        if (this.bankInformationSettings[event[i].id] === 'none') {
          this.isBankRequired = 'none';
          validatorStatus = false;
        }
      }
    } else {
      this.isBankRequired = false;
      validatorStatus = false;
    }
    this.updateBankDetailsValidators(validatorStatus);
  }

  handleTypeChange2() {
    if (this.isPerson) {
      if (this.isNewEntity) this.entityForm.get('name')?.patchValue('');
      this.entityForm.get('type')?.patchValue(2);
    } else {
      if (this.isNewEntity) this.entityForm.get('firstName')?.patchValue('');
      if (this.isNewEntity) this.entityForm.get('lastName')?.patchValue('');
      this.entityForm.get('type')?.patchValue(1);
    }
    this.changeFormValidators(this.isPerson);
  }

  handleTypeChange() {
    const isPersonType = 2;
    const isEntityType = 1;

    if (this.isNewEntity) {
      const fieldsToReset = this.isPerson ? ['name'] : ['firstName', 'lastName'];
      fieldsToReset.forEach((field) => this.entityForm.get(field)?.patchValue(''));
    }

    const typeValue = this.isPerson ? isPersonType : isEntityType;
    this.entityForm.get('type')?.patchValue(typeValue);

    this.changeFormValidators(this.isPerson);
  }

  changeFormValidators(isPerson: boolean): void {
    const controls = ['name', 'firstName', 'lastName'];

    controls.forEach((control) => {
      const formControl = this.entityForm.get(control);
      if (!formControl) return;

      if (isPerson) {
        if (control === 'firstName' || control === 'lastName') {
          formControl.addValidators([Validators.required]);
        } else {
          formControl.clearValidators();
        }
      } else {
        if (control === 'name') {
          formControl.addValidators([Validators.required]);
        } else {
          formControl.clearValidators();
        }
      }
      formControl.updateValueAndValidity();
    });
  }

  onSortCodeInput(event: any) {
    const value = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = this.formatSortCode(value);
    this.entityForm.get('sortCode')?.patchValue(event.target.value, { emitEvent: false });
  }

  private subscribeToSortCodeValueChange2() {
    this.subscribeToFormControl('sortCode', (value: string) => {
      const sanitizedValue = value.replace(/[^0-9]/g, '');
      const formattedValue = this.formatSortCode(sanitizedValue);
      this.entityForm.get('sortCode')?.patchValue(formattedValue, { emitEvent: false });
    });
  }

  private subscribeToSortCodeValueChange(group: FormGroup) {
    const sortCodeControl = group.get('sortCode');
    if (sortCodeControl) {
      const subscription = sortCodeControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(value => {
        const sanitizedValue = value?.replace(/[^0-9]/g, '');
        const formattedValue = this.formatSortCode(sanitizedValue);
        sortCodeControl.patchValue(formattedValue, { emitEvent: false });
      });
      this.subscriptions.push(subscription);
    }
  }

  private subscribeToFormControl(controlName: string, callback: (value: any) => void) {
    const control = this.entityForm.get(controlName);
    const subscription = control?.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(callback);

    if (subscription) {
      this.subscriptions.push(subscription);
    }
  }

  private formatSortCode(value: string): string {
    return value?.replace(/(\d{2})(?=\d)/g, '$1-');
  }

  addTagFn(name: string) {
    return { name: name, tag: true };
  }

  handleSearch(event: any) {
    if (event.term.length >= 3) {
      this.entitiesHttpService
        .getEntities({
          pageIndex: 0,
          perPage: 10000,
          name: event.term,
        })
        .subscribe((data) => {
          this.entityNameList = data.items.map((item) => {
            return { id: item.name, name: item.name };
          });
          this.addNewTag(event.term);
        });
    }
  }

  handleCompanySearch(event: any) {
    if (event.term.length >= 3) {
      this.entitiesHttpService
        .getEntities({
          pageIndex: 0,
          perPage: 10000,
          name: event.term,
        })
        .subscribe((data) => {
          this.entityNameList = data.items.map((item) => {
            return { id: item.name, name: item.name };
          });
          this.addNewTag(event.term);
        });
    }
  }

  handleChange(event: any) {
    if (event) {
      if (!event.id) {
        this.entityNameList.push({ id: event.name, name: event.name });
      }
      this.entityForm.get('name')?.patchValue(event.name, { emitEvent: true });
    } else {
      this.entityNameList = [];
    }
  }

  handleCompanyChange(event: any) {
    if (event) {
      if (!event.id) {
        this.organisationList.push({ id: event.name, name: event.name });
      }
      this.entityForm.get('company')?.patchValue(event.name, { emitEvent: true });
    } else {
      this.organisationList = [];
    }
  }

  addNewTag(searchTerm: string): any {
    const newTag = { id: searchTerm, name: searchTerm };
    this.entityForm?.get('name')?.patchValue(searchTerm, { emitEvent: true });
    return newTag;
  }

  addNewInput(type: string) {
    switch (type) {
      case 'email': {
        const emailFormArray = this.entityForm.get('email') as FormArray;
        const lastEmailControl = emailFormArray.at(emailFormArray.length - 1) as FormControl;
        if (lastEmailControl.valid && lastEmailControl.value.trim() !== '') {
          emailFormArray.push(this.fb.control('', [Validators.email]));
        }
        break;
      }
      case 'mobilePhones': {
        const mobilePhonesArray = this.mobilePhonesControls;
        const lastGroup = mobilePhonesArray.at(mobilePhonesArray.length - 1) as FormGroup;
        const currentPhone = `${lastGroup.value.countryCode}${lastGroup.value.areaCode}${lastGroup.value.mobileNumber}`;
        const isValidNumber = parsePhoneNumber(currentPhone)?.isValid();
        if (!isValidNumber) {
          lastGroup.setErrors({ invalidPhoneNumber: true });
          return;
        }
        if (lastGroup.valid) {
          mobilePhonesArray.push(this.createPhoneGroup());
        }
        break;
      }
      case 'homePhones': {
        const homePhonesFormArray = this.homePhonesControls;
        const lastGroup = homePhonesFormArray.at(homePhonesFormArray.length - 1) as FormGroup;
        const currentPhone = `${lastGroup.value.countryCode}${lastGroup.value.areaCode}${lastGroup.value.mobileNumber}`;
        const isValidNumber = parsePhoneNumber(currentPhone)?.isValid();
        if (!isValidNumber) {
          lastGroup.setErrors({ invalidPhoneNumber: true });
          return;
        }
        if (lastGroup.valid) {
          homePhonesFormArray.push(this.createPhoneGroup());
        }
        break;
      }
      case 'officePhones': {
        const officePhonesFormArray = this.officePhonesControls;
        const lastGroup = officePhonesFormArray.at(officePhonesFormArray.length - 1) as FormGroup;
        const currentPhone = `${lastGroup.value.countryCode}${lastGroup.value.areaCode}${lastGroup.value.mobileNumber}`;
        const isValidNumber = parsePhoneNumber(currentPhone)?.isValid();
        if (!isValidNumber) {
          lastGroup.setErrors({ invalidPhoneNumber: true });
          return;
        }
        if (lastGroup.valid) {
          officePhonesFormArray.push(this.createPhoneGroup());
        }
        break;
      }
    }
  }

  handleValidateMobilePhone(index: number) {
    const mobilePhonesArray = this.mobilePhonesControls;
    const lastGroup = mobilePhonesArray.at(index) as FormGroup;
    const currentPhone = `${lastGroup.value.countryCode}${lastGroup.value.areaCode}${lastGroup.value.mobileNumber}`;
    const isValidNumber = parsePhoneNumber(currentPhone)?.isValid();
    if (currentPhone.length && !isValidNumber) {
      lastGroup.setErrors({ invalidPhoneNumber: true }, { emitEvent: true });
    }
  }

  handleValidateHomePhone(index: number) {
    const homePhonesFormArray = this.homePhonesControls;
    const lastGroup = homePhonesFormArray.at(index) as FormGroup;
    const currentPhone = `${lastGroup.value.countryCode}${lastGroup.value.areaCode}${lastGroup.value.mobileNumber}`;
    const isValidNumber = parsePhoneNumber(currentPhone)?.isValid();
    if (currentPhone.length && !isValidNumber) {
      lastGroup.setErrors({ invalidPhoneNumber: true });
      return;
    }
  }

  handleValidateOfficePhone(index: number) {
    const officePhonesFormArray = this.officePhonesControls;
    const lastGroup = officePhonesFormArray.at(index) as FormGroup;
    const currentPhone = `${lastGroup.value.countryCode}${lastGroup.value.areaCode}${lastGroup.value.mobileNumber}`;
    const isValidNumber = parsePhoneNumber(currentPhone)?.isValid();
    if (currentPhone.length && !isValidNumber) {
      lastGroup.setErrors({ invalidPhoneNumber: true });
      return;
    }
  }

  removeInput(type: string, index: number) {
    switch (type) {
      case 'email':
        (this.entityForm.get('email') as FormArray).removeAt(index);
        break;
      case 'mobilePhones':
        (this.entityForm.get('mobilePhones') as FormArray).removeAt(index);
        break;
      case 'homePhones':
        (this.entityForm.get('homePhones') as FormArray).removeAt(index);
        break;
      case 'officePhones':
        (this.entityForm.get('officePhones') as FormArray).removeAt(index);
        break;
    }
  }

  addAddressGroup(): void {
    const addressFormArray = this.addressArray;
    const lastGroup = addressFormArray.at(addressFormArray.length - 1) as FormGroup;
    if (lastGroup.valid) {
      addressFormArray.push(this.createAddressGroup());
    }
    // this.addressArray.push(this.createAddressGroup());
  }

  addBankGroup(): void {
    const banksFormArray = this.bankDetailsArray;
    const lastGroup = banksFormArray.at(banksFormArray.length - 1) as FormGroup;
    if (lastGroup.valid) {
      const newGroup = this.createBankDetailsGroup();
      this.subscribeToSortCodeValueChange(newGroup);
      banksFormArray.push(newGroup);
    }
    // this.addressArray.push(this.createAddressGroup());
  }

  removeAddressGroup(index: number): void {
    const addressFormArray = this.addressArray;
    const removedGroup = addressFormArray.at(index) as FormGroup;
    this.deleteAddress.push(removedGroup.value.id);
    this.addressArray.removeAt(index);
  }

  removeBankGroup(index: number): void {
    const banksFormArray = this.bankDetailsArray;
    const removedGroup = banksFormArray.at(index) as FormGroup;
    this.deleteBanks.push(removedGroup.value.id);
    this.bankDetailsArray.removeAt(index);
  }

  createAddressGroup(): FormGroup {
    return this.fb.group({
      address1: ['', Validators.required],
      address2: [''],
      city: [null, Validators.required],
      state: [null],
      area: [''],
      postCode: [''],
      country: [null, Validators.required],
      isNew: true,
    });
  }

  createBankDetailsGroup(): FormGroup {
    return this.fb.group({
      ccy: [null],
      bankId: [null],
      bankName: [null],
      accountNumber: [null, this.isBankRequired ? [Validators.required] : []],
      sortCode: [null, this.isBankRequired ? [Validators.required] : []],
      swiftBic: [null, this.isBankRequired ? [Validators.required] : []],
      iban: [null],
      isNew: true,
    });
  }

  updateBankDetailsValidators(isBankRequired: boolean) {
    const banksFormArray = this.bankDetailsArray;

    banksFormArray.controls.forEach((control: any) => {
      // Add or remove 'required' validator based on isBankRequired
      const accountNumberControl = control.get('accountNumber');
      const sortCodeControl = control.get('sortCode');
      const swiftBicControl = control.get('swiftBic');

      if (isBankRequired) {
        accountNumberControl?.setValidators(Validators.required);
        sortCodeControl?.setValidators(Validators.required);
        swiftBicControl?.setValidators(Validators.required);
      } else {
        accountNumberControl?.clearValidators();
        sortCodeControl?.clearValidators();
        swiftBicControl?.clearValidators();
      }

      // Update validity after changing validators
      accountNumberControl?.updateValueAndValidity();
      sortCodeControl?.updateValueAndValidity();
      swiftBicControl?.updateValueAndValidity();
    });
  }

  createPhoneGroup(): FormGroup {
    return this.fb.group({
      countryCode: [''],
      areaCode: [''],
      mobileNumber: [''],
    });
  }

  handlePreviewCheck(event: any) {
    this.isShowPreviousInput = event.target.checked;
  }

  startDeleteEntity(): void {
    confirmMessage().then((result) => {
      if (result.isConfirmed) {
        this.handleDeleteEntity();
      }
    });
  }

  handleDeleteEntity(): void {
    this.spinnerService.setShowSpinner(true);
    this.entitiesHttpService.deleteEntity(this.currentEntity.id).subscribe({
      next: (data: any) => {
        this.spinnerService.setShowSpinner(false);
        this.closeDialogEvent.emit(true);
      },
      error: (err: any) => {
        this.spinnerService.setShowSpinner(false);
        this.closeDialogEvent.emit(true);
      },
    });
  }

  toggleChange(event: any): void {
    this.isPerson = event === 'person';
  }


  getEntitiesData(searchTerm: string) {
    const rawData = this.entityForm.value; // Assuming you have a form with filters
    const queryParams: Partial<EntityQueryParams> = {
      pageIndex: 0,
      perPage: 10000,
      role: rawData.roleId?.[0],
      name: searchTerm.toLowerCase()
    };

    if (rawData.roleId?.[0] && searchTerm.length > 2) {
      return this.entitiesHttpService.getEntities(queryParams);
    } else {
      return [];  // Return empty array if search term is too short or role is missing
    }
  }

  // Process the response to adjust documents
  processEntities(response: EntityResponse) {
    response.items.forEach((item: any) => {
      if (item.documents) {
        item.documents = {
          ...item.documents,
          perPerformanceFile: false,
          actManagementAccountsFile: false,
          staStatutoryFilingsFile: false,
          taxVatReturnsFile: false,
          licLicenseFile: false,
          misOtherInformationFile: false,
        };
        item.hasCheckedDoc = Object.values(item.documents).some((value) => typeof value === 'boolean' && value);
      } else {
        item.documents = {
          entityId: item.id,
          etrFile: false,
          fxFile: false,
          organisationFile: false,
          POFile: false,
          PoDFile: false,
          signedFile: false,
          proofFile: false,
          perPerformanceFile: false,
          actManagementAccountsFile: false,
          staStatutoryFilingsFile: false,
          taxVatReturnsFile: false,
          licLicenseFile: false,
          misOtherInformationFile: false,
        };
      }
    });

    this.filteredOptions = [...response.items];
  }
}
